import btoa from 'btoa';
import TrackWrapper from '~/components/common/TrackWrapper';
import { popularModels } from '~/constants/home/popularModels';
import Sections from '~/constants/home/sections';
import { useScreenSize } from '~/context/common/DeviceContext';
import { useGetConsumerHref } from '~/hooks/common';
import useCarouselSettings from '~/hooks/home/useCarouselSettings';
import { nativeSrpPayload } from '~/native/common/utils';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import Carousel from '../Carousel';

function createHref(make: string, model: string) {
  const cvnaId = btoa(
    JSON.stringify({
      filters: { makes: [{ parentModels: [{ name: model }], name: make }] }
    })
  );

  return `/cars/filters?cvnaid=${cvnaId}`;
}

function PopularModels() {
  const getHref = useGetConsumerHref();
  const { width: screenWidth } = useScreenSize();
  const widthGap = screenWidth < 1024 ? 296 : 316;
  const { values, carouselRef } = useCarouselSettings({
    heading: 'Shop Popular Models',
    maxLength: popularModels.length,
    widthGap
  });

  const viewEvent = {
    eventName: 'Viewed - Home feed section',
    customAttributes: {
      description: 'Popular Models',
      isCarousel: true,
      content: {
        models: popularModels.map(vehicle => `${vehicle.make}-${vehicle.model}`)
      }
    }
  };

  return (
    <TrackWrapper event={viewEvent} className="pb-40">
      <Carousel
        {...values}
        ref={carouselRef}
        dataQa="popular-models"
        isNonVehicleCarousel
      >
        {popularModels.map(({ image, make, model }) => (
          <a
            href={getHref(createHref(make, model))}
            key={`${make}-${model}`}
            data-analytics-id="Home feed card"
            data-analytics-attributes={JSON.stringify({
              description: 'Popular models tile',
              content: `${make}-${model}`
            })}
            data-native-payload={nativeSrpPayload}
          >
            <div className="relative h-[292px] w-full rounded-md bg-grey-1">
              <h3 className="px-24 pb-16 pt-32 text-blue-6 tl-header-xl">
                {make} {model}
              </h3>
              <img
                className="absolute bottom-0 right-0 object-none xl:h-[212px]"
                src={image}
                alt={`${make} ${model}`}
              />
            </div>
          </a>
        ))}
      </Carousel>
    </TrackWrapper>
  );
}

export default withErrorBoundary(
  PopularModels,
  undefined,
  undefined,
  Sections.PopularModels
);
